import { FC, useRef } from "react";
import useScreenSize from "../../../../custom-hooks/base-hooks/useScreenSize";
import { useClickOutOfElement } from "../../../../custom-hooks/base-hooks/useClickOutOfElement";
import { AutocompletedWorkDTO } from "../../../../domain/models/dto/WorkDTO";
import { useTranslation } from "react-i18next";

interface AutocompletedWorkTitleTooltipProps {
    data: AutocompletedWorkDTO[];
    resetCallback: () => void;
    selectCallback: (value: string) => void;
}

const AutocompletedWorkTitleTooltip: FC<AutocompletedWorkTitleTooltipProps> = (props) => {
    const { t } = useTranslation();
    const { upTo1024 } = useScreenSize();
    const tooltipRef = useRef<HTMLDivElement>();

    useClickOutOfElement(tooltipRef, () => {
        props.resetCallback();
    });

    if (!props.data.length) {
        return <></>;
    }

    return (
        <div ref={tooltipRef} className="relative flex items-center cursor-pointer">
            <div className="absolute top-2 pb-3 z-10 px-[46px] flex flex-col gap-3 dmax2:gap-2 items-center justify-center bg-backgroundInput w-full dmin2:py-4 dmax2:pt-4 rounded-[7px] transition duration-300">
                {props.data.map((item, index) => (
                    <div
                        onClick={() => {
                            props.selectCallback(item.title);
                            props.resetCallback();
                        }}
                        key={"autocompleted_title_" + item.title}
                        className={`
                        flex justify-between items-center
                        H16 dmax2:H14 pl-4
                        text-textWhite text-center
                        w-full h-[${upTo1024 ? "32" : "45"}px]
                        hover:font-[500] cursor-pointer
                        hover:bg-textFaded
                        ${upTo1024 ? "" : "rounded-md"}
                        ${upTo1024 && index !== props.data.length - 1 ? "border-b border-textFaded" : ""}
                        transition-all duration-300
                        group
                    `}
                    >
                        <span className={`truncate whitespace-nowrap max-w-[${upTo1024 ? "100" : "60"}%]`}>
                            {item.title}
                        </span>
                        {item.categories[0]?.id && !upTo1024 && (
                            <div
                                key={`work-category-${index}`}
                                id={item.categories[0].id}
                                className="truncate whitespace-nowrap H20 dmax2:H16B pr-[22px] text-textFaded decoration-1 underline-offset-[8px] group-hover:text-backgroundInput"
                            >
                                {t("catalog.inCategory")} &quot;{t(`work.categories.${item.categories[0].category}`)}
                                &quot;
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AutocompletedWorkTitleTooltip;
